import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Orbit, SatelliteDish, Rocket, Globe } from 'lucide-react';
import { useApp } from '../context/AppContext';

export default function BottomNav() {
  const nav = useNavigate();
  const loc = useLocation();
  const { profile, unreadNotifCount } = useApp();
  const is = (p) => loc.pathname === p;

  const Item = ({ children, active, onClick, label }) => (
    <button
      onClick={onClick}
      className={`press orbit-nav-item ${active ? 'is-active' : ''}`}
      aria-label={label}
    >
      {children}
      <span>{label}</span>
    </button>
  );

  return (
    <div className="absolute bottom-0 left-0 right-0 z-30 orbit-bottom-nav">
      <Item label="Home" active={is('/home')} onClick={() => nav('/home')}>
        <Orbit strokeWidth={1.7} />
      </Item>
      <Item label="Alerts" active={is('/notifications')} onClick={() => nav('/notifications')}>
        <span className="relative">
          <SatelliteDish strokeWidth={1.7} />
          {unreadNotifCount > 0 && (
            <span className="absolute rounded-full" style={{ width: 8, height: 8, top: -2, right: -3, background: '#ff8fe4', border: '1px solid #0a0b1e' }} />
          )}
        </span>
      </Item>
      <Item label="Broadcast" active={is('/compose')} onClick={() => nav('/compose')}>
        <Rocket strokeWidth={1.8} />
      </Item>
      <Item label="Galaxies" active={is('/explore-galaxies')} onClick={() => nav('/explore-galaxies')}>
        <Globe strokeWidth={1.7} />
      </Item>
      <Item label="Profile" active={is('/profile')} onClick={() => nav('/profile')}>
        <span className="orbit-nav-avatar rounded-full overflow-hidden flex items-center justify-center" style={{
          border: is('/profile') ? '2px solid #cdb8ff' : '2px solid rgba(183,158,222,.6)',
        }}>
          {profile?.avatar_url ? (
            <img src={profile.avatar_url} alt="" className="w-full h-full object-cover" />
          ) : (
            <span className="w-full h-full flex items-center justify-center font-bold text-[10px]" style={{ background: 'linear-gradient(135deg,#ff5bd1,#6b4fd6)', color: '#fff' }}>
              {(profile?.display_name || profile?.username || '?')[0]?.toUpperCase()}
            </span>
          )}
        </span>
      </Item>
    </div>
  );
}
